import { get } from 'lodash';
import React, { Component } from 'react';
import ReactCountryFlag from "react-country-flag";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { countryApiAction } from '../../commonAction/countryApiAction';
import { connect } from 'react-redux';
import UtilService from '../utils/utils';

export class CountryFlag extends Component {
    constructor(props) {
        super(props)
        this.state = {
            countryCode: ""
        }
    }


    componentDidMount = async () => {
        let countryApiData = await UtilService.getCountryList();
        if (countryApiData === null) {
            await this.props.dispatch(countryApiAction())
            countryApiData = get(this.props, 'countryApiReducer.countryApiData', null);
        }
        let countryList = (countryApiData && countryApiData.length) > 0 ? JSON.parse(countryApiData).countries : [];
        let countryName = this.props.countryName ? this.props.countryName : null;
        let countryCode = this.props.countryCode ? this.props.countryCode : null;
        if (countryCode) {
            this.setState({ countryCode })
            return;
        }
        if (countryList && countryList.length > 0 && countryName != null) {
            let countryCode = countryList.filter(t => t.countryName == countryName);
            if (countryCode && countryCode.length > 0) {
                this.setState({ countryCode: countryCode[0].countryId })
            }
        }
    }


    render() {
        let width = this.props.width ? this.props.width : '1.5em';
        let height = this.props.height ? this.props.height : '1.5em'
        return (
            <>
                <ReactCountryFlag
                    key={this.props.key}
                    countryCode={this.state.countryCode}
                    svg
                    // cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                    // cdnSuffix="svg"
                    style={{
                        width: width,
                        height: height,
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    countryApiReducer: state.countryApiReducer,
    login: state.loginReducer,
    ui: state.ui,
    apiReducer: state.apiReducer
});

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CountryFlag);

